export const handleImageError = (err: any) => {
	err.target.onerror = null;
	err.target.src = `${require("../assets/images/placeholder.png")}`;
};
